import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import {
  KnBrCartBaseTranslationChunksConfig,
  KnBrCartBaseTranslations,
} from 'src/feature-libs/kn-br-cart/base/assets/translations/translation';
import {
  savedCartTranslations,
  savedCartTranslationChunksConfig,
} from 'src/feature-libs/kn-br-cart/saved-carts/assets/translation/translation';
import { CART_SAVED_CART_FEATURE } from 'src/feature-libs/kn-br-cart/saved-carts/root/feature-name';
import { KnBrSavedCartRootModule } from 'src/feature-libs/kn-br-cart/saved-carts/root/kn-br-saved-cart-root.module';

@NgModule({
  imports: [KnBrSavedCartRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [CART_SAVED_CART_FEATURE]: {
          module: () =>
            import('../../../../feature-libs/kn-br-cart/saved-carts/kn-br-saved-cart.module').then(
              (m) => m.KnBrSavedCartModule
            ),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: savedCartTranslations,
        chunks: savedCartTranslationChunksConfig,
        fallbackLang: 'en',
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: KnBrCartBaseTranslations,
        chunks: KnBrCartBaseTranslationChunksConfig,
        fallbackLang: 'en',
      },
    }),
  ],
})
export class SavedCartFeatureModule {}
